import { Client as StyletronClient, Server as StyletronServer } from 'styletron-engine-atomic';

const CLASSNAME_PREFIX = 'jpx-';
const SSR_CRITICAL_STYLESHEET_CLASS_NAME = '_jpx_ep_styletron_hydrate_';

export const engine = import.meta.env.SSR
  ? new StyletronServer({
      prefix: CLASSNAME_PREFIX,
    })
  : new StyletronClient({
      prefix: CLASSNAME_PREFIX,
      hydrate: document.getElementsByClassName(
        SSR_CRITICAL_STYLESHEET_CLASS_NAME,
      ) as HTMLCollectionOf<HTMLStyleElement>,
    });

export const getSSRCriticalStylesheetsHtml = () => {
  if (!import.meta.env.SSR) {
    return '';
  }

  return (engine as StyletronServer).getStylesheetsHtml(SSR_CRITICAL_STYLESHEET_CLASS_NAME);
};
